<template>
<div>
  <v-form>
    <div class="d-flex align-center">
      <v-select
        :items="hours"
        item-title="title"
        item-value="value"
        variant="outlined"
        suffix="h"
        density="compact"
        hide-details="auto"
        v-model="inputHour"
        color="primary"
      ></v-select>
      <div class="mx-2">
        :
      </div>
      <v-select
        :items="minutes"
        item-title="title"
        item-value="value"
        variant="outlined"
        suffix="m"
        density="compact"
        hide-details="auto"
        v-model="inputMinute"
        color="primary"
      ></v-select>
    </div>
  </v-form>
</div>
</template>

<script lang="ts">
import ValidationMixin from '@/mixins/ValidationMixin';
import { defineComponent } from 'vue'

//const hours = [...Array(24)].map((emp, i) => i)
//const minutes = [...Array(4)].map((emp, i) => i * 15)
const hours = [...Array(24)].map((_, i) => ({
  title: String(i).padStart(2, '0'), // 表示は "00", "01", "02"...
  value: i                           // 裏側の値は 0, 1, 2...
}))

const minutes = [...Array(4)].map((_, i) => ({
  title: String(i * 15).padStart(2, '0'), // 表示は "00", "15", "30", "45"
  value: i * 15                           // 裏側の値は 0, 15, 30, 45
}))

export default defineComponent({
  name: 'TimeInput',

  mixins: [ValidationMixin],

  emits:['update:modelValue'],

  props: {
    modelValue: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    hours,
    minutes
  }),

  computed: {
    inputHour: {
      get(): number {
        return Math.floor(this.modelValue / 60);
      },
      set(value: number) {
        this.$emit('update:modelValue', value * 60 + this.inputMinute)
      }
    },
    inputMinute: {
      get(): number {
        return this.modelValue % 60;
      },
      set(value: number) {
        this.$emit('update:modelValue', this.inputHour * 60 + value)
      }
    },
  },
})
</script>